import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconSuccess } from 'src/assets/icons/icon-success.svg';

import { EPaymentStatus } from 'src/type';
import { useCustomSearchParams } from 'src/hook/useCustomSearchParams';

import { selectPayment, selectWidgetSettings } from 'src/store/slice/payment/state';

import PopupContent from 'src/components/popups/popupContent';
import Button from 'src/components/button/Button';

import './popup-completed-payment.scss';

const PopupCompletedPayment: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const payment = useSelector(selectPayment);
  const widgetSettings = useSelector(selectWidgetSettings);

  const { redirect } = useCustomSearchParams();

  const [isShowPopup, setShowPopup] = useState<boolean>(false);

  /**
   * useEffect to show popup completed payment
   */
  useEffect(() => {
    if (payment && payment.client_status === EPaymentStatus.Completed) {
      setShowPopup(true);
    }
  }, [payment]);

  return (
    <PopupContent
      wrapperClass="popup-completed"
      visible={isShowPopup}
      title={t('POPUP_COMPLETED_PAYMENT_TITLE.TRANSACTION_CONFIRMED') || undefined}
    >
      <i className="popup-completed-icon">
        <IconSuccess />
      </i>

      <p className="popup-completed-description">
        {t('POPUP_COMPLETED_PAYMENT_DESCRIPTION.YOUR_ORDER_ID', { id: payment?.id })}
      </p>

      {(redirect || widgetSettings.redirectUrl) && (
        <Button
          wrapperClass="popup-completed-button"
          message={t('POPUP_COMPLETED_PAYMENT_BUTTON.BACK_TO_STORE')}
          onEvent={() => (window.location.href = redirect || widgetSettings.redirectUrl)}
        />
      )}
    </PopupContent>
  );
};

export default PopupCompletedPayment;
